class ERPService {
  constructor() {
    this.baseURL = 'https://aplicaciones.salvadorvertical.com/SAT/webapi/list';
    this.accessToken = 'aPnBSLFLvF8jiNJ_FDzEpq-q7HrElSFhf0_Fyxl1RTQd9JZadJ8dR0J3L-WnMT6w195uGDcLsL6H3C0tUPrwvWSJdcoJSD0-I3OouFvsTEpL_SaUnCXiEK48TMPZRzo5QZCBbR13-kMuLx2GL_yvasU81PcUGXht8XYZxlsN-BPvKiv1l0tSW4gMnmQnQWMW_CWHFOvkVAmnjyhUk9qdubS9oaJ6mXjLdLMc0rWNESSgXwuZWHHSjQl-jtdiAs9AOKzKvcyzSDG7kuwpp3o7ClYXVN7UesYP1NSrywDZLSI';
  }

  /**
   * Obtiene artículos consumibles de las familias 2101, 2201 y 2202 del ERP
   * @param {string} searchTerm - Término de búsqueda para filtrar por descripción (Descrip) o ID (IdArticulo)
   * @returns {Promise<Array>} Lista de artículos
   */
  async getConsumibles(searchTerm = '') {
    try {
      // Familias a buscar
      const familias = ['2101', '2201', '2202'];
      
      // Hacer llamadas en paralelo para todas las familias
      const promesas = familias.map(async (familia) => {
        const url = `${this.baseURL}/Articulo_API?page=0&pageSize=5000&filter=IdFamilia='${familia}'&access_token=${this.accessToken}`;
        
        console.log(`🔗 [ERP] Llamando a URL para familia ${familia}:`, url);

        try {
          const response = await fetch(url, {
            method: "GET",
            redirect: "follow"
          });

          if (!response.ok) {
            console.warn(`⚠️ [ERP] Error en familia ${familia}: HTTP ${response.status}`);
            return [];
          }

          const result = await response.text();
          console.log(`✅ [ERP] Respuesta recibida para familia ${familia}:`, result.length, 'caracteres');
          
          // Parsear la respuesta como JSON
          const articulos = JSON.parse(result) || [];
          console.log(`✅ [ERP] Artículos parseados para familia ${familia}:`, articulos.length);
          
          return articulos;
        } catch (error) {
          console.error(`❌ [ERP] Error obteniendo consumibles de familia ${familia}:`, error);
          // Continuar con las otras familias aunque una falle
          return [];
        }
      });

      // Esperar todas las llamadas y combinar resultados
      const resultados = await Promise.all(promesas);
      let articulos = resultados.flat();
      
      console.log('✅ [ERP] Total de artículos combinados:', articulos.length);

      // Eliminar duplicados por IdArticulo (por si algún artículo aparece en múltiples familias)
      const articulosUnicos = [];
      const idsVistos = new Set();
      for (const articulo of articulos) {
        if (articulo.IdArticulo && !idsVistos.has(articulo.IdArticulo)) {
          idsVistos.add(articulo.IdArticulo);
          articulosUnicos.push(articulo);
        }
      }
      articulos = articulosUnicos;
      console.log('✅ [ERP] Artículos únicos después de eliminar duplicados:', articulos.length);

      // Filtrar por término de búsqueda si se proporciona (busca en Descrip e IdArticulo)
      if (searchTerm && searchTerm.trim()) {
        const searchLower = searchTerm.toLowerCase();
        articulos = articulos.filter(articulo => 
          (articulo.Descrip && articulo.Descrip.toLowerCase().includes(searchLower)) ||
          (articulo.IdArticulo && articulo.IdArticulo.toLowerCase().includes(searchLower))
        );
      }

      // Transformar los datos para que sean más fáciles de usar
      return articulos.map(articulo => ({
        idArticulo: articulo.IdArticulo,
        descripcion: articulo.Descrip,
        tipoCantidad: articulo.TipoCantidad,
        cantidadBulto: articulo.CantidadBulto,
        notas: articulo.Notas,
        fechaAlta: articulo.FechaAlta,
        estado: articulo.Estado,
        idFamilia: articulo.IdFamilia,
        material: articulo.Material,
        observaciones: articulo.Observaciones,
        codigoFabricante: articulo.CodigoFabricante,
        idProveedorPreferencial: articulo.IdProveedorPreferencial
      }));

    } catch (error) {
      console.error('❌ [ERP] Error obteniendo consumibles:', error);
      
      // Si es un error de parsing JSON, mostrar el texto original
      if (error instanceof SyntaxError) {
        console.error('❌ [ERP] Error parsing JSON. Respuesta recibida:', error.message);
        throw new Error('Error al procesar la respuesta del ERP: formato inválido');
      }
      
      throw new Error(`Error al obtener consumibles del ERP: ${error.message}`);
    }
  }

  /**
   * Busca un artículo específico por ID
   * @param {string} idArticulo - ID del artículo a buscar
   * @returns {Promise<Object|null>} Artículo encontrado o null
   */
  async getArticuloById(idArticulo) {
    try {
      const articulos = await this.getConsumibles();
      return articulos.find(articulo => articulo.idArticulo === idArticulo) || null;
    } catch (error) {
      console.error('Error obteniendo artículo por ID:', error);
      throw error;
    }
  }
}

export default new ERPService();
